import { defaultTo, prop, last } from 'ramda';
export const parseFileNameFromS3Url = (url = '') => {
  return url
    ? decodeURIComponent(
        defaultTo('', prop(0, last(url.split('/')).split('?')))
      )
    : '';
};
